import { NextRouter } from 'next/router';
import { DashboardJson } from '../modules/models';
import { cloneDeep } from 'lodash';
import { toast } from '@appd/uik';
import { useState } from 'react';

export const getTENANTLayerId = () => {
  // appd-next-tenant-id doesn't exist on local dev, fallback to fso-devplat(55f8da9d...)
  return sessionStorage.getItem('appd-next-tenant-id') ?? '47a01df9-54a0-472b-96b8-7c8f64eb7cbf';
};

export const getLOCALUSERLayerId = () => {
  const tenantId = getTENANTLayerId();
  const userId = sessionStorage.getItem('appd-next-principal-id') ?? '';

  return `${tenantId}@${userId}`;
};

const orionReq = (method: string, body: string | null, id?: string) =>
  new Request(`/session/api/ext/objstore/v1beta/objects/platformui:dashboard/${id ?? ''}`, {
    headers: {
      Accept: 'application/json; charset=UTF-8',
      'layer-type': 'TENANT',
      'layer-id': getTENANTLayerId(),
      'Content-Type': 'application/json',
    },
    method,
    body,
  });

export const ORION_CRUD_UTILS = {
  post: (dashboardJson: DashboardJson) => fetch(orionReq('POST', JSON.stringify(dashboardJson))),
  put: (dashboardJson: DashboardJson, dashboardName: string) =>
    fetch(orionReq('PUT', JSON.stringify(dashboardJson), dashboardName)),
  delete: (dashboardName: string) => fetch(orionReq('DELETE', null, dashboardName)),
};

export const cloneDashboard = async (
  dashboardJson: DashboardJson,
  title: string = '',
  description: string = '',
): Promise<DashboardJson> => {
  let cDashboard = cloneDeep(dashboardJson);
  const randomNumber = Math.floor(Math.random() * 99999);

  cDashboard.name = `${cDashboard.name}${randomNumber}`;
  cDashboard.author = 'User';
  cDashboard.title = title ? title : `Duplicate of ${cDashboard.title}`;
  cDashboard.description = description ?? cDashboard.description;
  // add tag templateType:dashboard so dashboard will show in dashboard list
  cDashboard['__META__!'] = { tags: { templateType: 'dashboard' } };

  const ERROR = 'ERROR' as const;
  const toastError = {
    copy: false,
    description: 'Duplication failed',
    icon: ERROR,
    title: 'ERROR',
  };

  await ORION_CRUD_UTILS.post(cDashboard)
    .then(response => {
      if (!response.ok) {
        toast(toastError);
        return;
      }
    })
    .catch(() => {
      toast(toastError);
      return;
    });

  return cDashboard;
};

export const saveTemplateChangesToOrion = async (dashboardJson: DashboardJson) => {
  const dashboardName = `${dashboardJson.name}`;
  // add tag templateType:dashboard so dashboard will show in dashboard list
  dashboardJson['__META__!'] = { tags: { templateType: 'dashboard' } };

  await ORION_CRUD_UTILS.put(dashboardJson, dashboardName)
    .then((res: any) => (res.status === 404 ? ORION_CRUD_UTILS.post(dashboardJson) : res))
    .then((res: any) => {
      if (res.ok) {
        toast({
          copy: false,
          description: `${dashboardName} Saved`,
          icon: 'SUCCESS',
          title: 'SUCCESS',
        });
      }
    })
    .catch(() => {
      toast({
        copy: false,
        description: 'Save failed',
        icon: 'ERROR',
        title: 'ERROR',
      });
    });
};

export const deleteDashboard = async (dashboardJson: DashboardJson): Promise<boolean> => {
  const ERROR = 'ERROR' as const;
  const toastError = {
    copy: false,
    description: 'Delete failed',
    icon: ERROR,
    title: 'ERROR',
  };

  await ORION_CRUD_UTILS.delete(dashboardJson.name as string)
    .then(response => {
      if (response.ok) {
        toast({
          copy: false,
          description: `${dashboardJson.title} Deleted`,
          icon: 'SUCCESS',
          title: 'SUCCESS',
        });
      } else {
        toast(toastError);
        return false;
      }
    })
    .catch(() => {
      toast(toastError);
      return false;
    });
  return true;
};
